import { Injectable, TemplateRef } from '@angular/core';
import { BaseControl, Textbox, Custom, DateTimePicker, TextArea } from '@app/shared';
import { Validators } from '@angular/forms';


@Injectable()
export class DocumentExpInventoryFormService {

  constructor() { }

  /**
   *  Construye y retorna el formulario para modificar la fecha de inventario
   * @return {*}  {BaseControl<any>[]}
   * @memberof DocumentExpInventoryFormService
   */
  getFormDocumentInventory(
      dateInventory?:any
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'fecha_inventario',
        type: 'number',
        label: 'Año de inventario',
        order: 1,
        size: 'col-3',
        value: dateInventory ? dateInventory : null,
        validations: {
            validators: [Validators.required]
          }
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/all/document-exp-inventory-form/shared/document-exp-inventory-form.form.service.ts